//////LIBRARY//////
import React, { useEffect, useState, Fragment } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
import { cloneDeep, isEmpty, isUndefined, isEqual, map, filter } from 'lodash'
import { useForm } from 'react-hook-form'
//////COMPONENTS//////
import { translationsManagerActionCreators, columnsActionCreators } from '../../store/actions'
import UseCheckAll from '../../hooks/UseCheckAll'
import { PageWrapperGrids, InputLogin, SelectInputWrapper, SelectInput } from '../../theme/GlobalCss'
import TooltipHelp from '../../components/TooltipHelp'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import ArrowUp from '../../assets/icones/global/arrow-up-big.svg'
import ArrowDown from '../../assets/icones/global/arrow-down-big.svg'
import ArrowUpGrey from '../../assets/icones/global/arrow-up-big-grey.svg'
import ArrowDownGrey from '../../assets/icones/global/arrow-down-big-grey.svg'

//////STYLED//////
const CustomTable = styled.div`
	& > div > form {
		display: none;
	}
`
const TranslationsManagerWrapper = styled.div`
	position: relative;
`
const PageWrapperHeaderGrids = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin: auto;
	width: calc(100% - 33px);
	& > div {
		min-height: 32px;
		margin-bottom: 3px;
		width: calc((100% - 33px) / 3);
	}
`
const LanguagePartHeader = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
`
const LanguagePartLabel = styled.label`
	color: ${(props) => props.theme.colors.primary};
	font-weight: bold;
	margin-right: 13px;
`
const LanguagePartFlag = styled.img`
	margin-right: auto;
	max-height: 17px;
`
const TranslationIndexPartHeader = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
`
const LanguagePartOverflow = styled(PageWrapperGrids)`
	overflow-y:scroll;
	max-height: calc(100vh - 370px);
	box-sizing: border-box;
	grid-column-gap: 0px;

	::-webkit-scrollbar {
		width: 15px;
		background-color: rgba(0,0,0,.15);
	}
	::-webkit-scrollbar-button:vertical:decrement:single-button {
		background: no-repeat url(${ArrowUp}) center;
		height:15px;
  	} 
	::-webkit-scrollbar-button:vertical:decrement:single-button:active {
		background: no-repeat url(${ArrowUpGrey}) center;
		height:15px;
  	}
	::-webkit-scrollbar-button:vertical:increment:single-button {
		background: no-repeat url(${ArrowDown}) center;
		height:15px;
  	}
	::-webkit-scrollbar-button:vertical:increment:single-button:active {
		background: no-repeat url(${ArrowDownGrey}) center;
		height:15px;
  	}
	::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 	
	}
	::-webkit-scrollbar-thumb {
		background: #4D4F5C; 
	}
	::-webkit-scrollbar-thumb:active {
	background rgba(77, 79, 92, 0.7); 
	}
	& {
		scrollbar-color: #4D4F5C #E5E5E5;
		scrollbar-width: thin;
	}	
	& > div{
		
		box-sizing: border-box;
	}
`
const ReferentialLanguagePartResultWrapper = styled.div`
	display: grid;
	& > div {
		border: 1px solid ${(props) => props.theme.colors.TabNav.border};
		overflow-x: auto;
		height: 52px;
		overflow-y: hidden;
		text-align: right;
		margin-bottom: -1px;
	}
`
const LanguageItemSpan = styled.span`
	line-height: 52px;
	white-space: pre;
	padding: 17px 20px;
`
const TranslateLanguagePartResultWrapper = styled.div`
	display: grid;
	& > form > div {
		background-color: ${(props) => props.theme.colors.table.header.main};
		border: 1px solid ${(props) => props.theme.colors.TabNav.border};
		margin-bottom: -1px;
		padding: 10px 20px;
		& > input {
			width: 100%;
		}
	}
`
const TranslationIndexPartResultWrapper = styled.div`
	display: grid;
	& > div {
		border: 1px solid ${(props) => props.theme.colors.TabNav.border};
		overflow-x: auto;
		height: 52px;
		overflow-y: hidden;
		text-align: center;
		margin-bottom: -1px;
	}
`
//////STYLED//////

const TranslationsManager = () => {
	const [showModal, setShowModal] = useState(false)
	const [row, setRow] = useState({})
	const [paging, setPaging] = useState({ page: '0', size: '250' })

	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {},
		paging: {
			fnSendTo: (paging) => handlePagingTranslationsManager(paging),
		},
	})

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	const { user, translations, translationsManager, translationsFilters, isSearchfieldUpdated } = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			translationsManager: state.translationsManager,
			translationsFilters: state.translationsManager.header,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
		}),
		shallowEqual
	)
	const { register, getValues, setValue } = useForm()
	const actionsTranslationsManager = bindActionCreators(translationsManagerActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())

	/////////////////////////////// HANDLER //////////////////////////////////////

	const handleModal = (dataRow) => {
		setRow({ ...dataRow })
		setShowModal((prevState) => !prevState)
	}

	const handlePagingTranslationsManager = (paging) => {
		setPaging(paging)
		actionsTranslationsManager.getListTranslations(filters, paging)
	}

	const handleTranslationChange = (idLanguage, id, value, prevValue) => {
		if (value !== prevValue && value.length > 0) {
			const data = {
				idTranslation: id,
				translationText: value,
			}
			actionsTranslationsManager.setTranslation(idLanguage, data)
		}
		if (value.length === 0) {
			setValue(`${id}_input`, prevValue)
		}
	}
	// handler search bar

	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleSubmit = (target = '', value) => {
		const currentFilters = cloneDeep(filters)
		if (target !== 'searchField') {
			map(currentFilters.filtersSelection[target].filterElements, (elem) => {
				elem.active = elem.id === parseInt(value) ? true : false
			})
		}
		if (isEqual(currentFilters, prevFilter)) return // guard to call if no change

		setFilters(currentFilters)
		setPrevFilter(currentFilters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = { page: '0', size: '250' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}

		filtersOut = { ...searchFieldUpdated, ...currentFilters }
		const params = {
			...currentFilters,
			withFilters: true,
		}

		actionsTranslationsManager.getListTranslations(params, pg)
	}

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		const filtersCp = cloneDeep(translationsFilters)
		filtersCp.withFilters = true
		setFilters(filtersCp)
		setPrevFilter(filtersCp)
	}, [translationsFilters])

	useEffect(() => {
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		if (filters.searchField !== searchValue) return
		handleSubmit('searchField')
	}, [filters.searchField])

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		if (!isEmpty(translationsManager) && !isUndefined(translationsManager)) {
			cfg.paging = {
				totalElements: translationsManager.paging.totalElements,
				totalPages: translationsManager.paging.totalPages,
				fnSendTo: (paging) => handlePagingTranslationsManager(paging),
			}
			setConfigTableTitle(cfg)
		}
	}, [translationsManager])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.name = translations['page__translationManagement__title']
		cfg.noColumnFilter = true
		cfg.actions.rest = [
			() => (
				<SelectInputWrapper blueColor>
					<SelectInput name="isEmptyTranslation" onChange={(e) => handleSubmit('isEmptyTranslation', e.target.value)}>
						{map(filters.filtersSelection?.isEmptyTranslation.filterElements, (elem, id) => {
							const o = filter(filters.filtersSelection?.isEmptyTranslation.filterElements, { active: true })[0]
							return (
								<option key={id} value={elem.id} selected={o.id === elem.id ? true : null}>
									{translations[elem.label]}
								</option>
							)
						})}
					</SelectInput>
				</SelectInputWrapper>
			),
		]
		setConfigTableTitle(cfg)
	}, [filters, translations])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}

		setConfigTableTitle(cfg)
	}, [searchValue])

	useEffect(() => {
		if (isUndefined(user)) return

		const filtersCp = {
			withFilters: false,
			filtersSelection: null,
			searchField: null,
			searchFieldUpdated: false,
		}

		actionsTranslationsManager.getListTranslations(filtersCp)
		setFilters(filtersCp)
	}, [user])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			<TranslationsManagerWrapper>
				<CustomTable>
					<TableTitle currentPaging={paging} inputColumns={[]} inputData={[]} inputConfig={configTableTitle} />
				</CustomTable>
				{translationsManager.items && (
					<Fragment>
						<PageWrapperHeaderGrids grids={3}>
							<LanguagePartHeader>
								<LanguagePartFlag src={`/${translationsManager.paging.refLangFlag}`} />
								<LanguagePartLabel>{translations['page__translationManagement__subTitle__referentialLanguage']} :</LanguagePartLabel>
								<SelectInputWrapper blueColor>
									<SelectInput name="referentialLanguage" onChange={(e) => handleSubmit('referentialLanguage', e.target.value)}>
										{map(filters.filtersSelection?.referentialLanguage.filterElements, (elem, id) => {
											const o = filter(filters.filtersSelection?.referentialLanguage.filterElements, { active: true })[0]
											return (
												<option key={id} value={elem.id} selected={o.id === elem.id ? true : null}>
													{elem.label}
												</option>
											)
										})}
									</SelectInput>
								</SelectInputWrapper>
							</LanguagePartHeader>
							<LanguagePartHeader>
								<LanguagePartFlag src={`/${translationsManager.paging.toTranslateLangFlag}`} />
								<TooltipHelp childrenPos={2} content={'tooltipHelp__admin__modal__body__translationManagement__requiredField'}>
									<LanguagePartLabel>
										{translations['page__translationManagement__subTitle__translationLanguage']} :
									</LanguagePartLabel>
								</TooltipHelp>
								<SelectInputWrapper blueColor>
									<SelectInput name="translationLanguage" onChange={(e) => handleSubmit('translationLanguage', e.target.value)}>
										{map(filters.filtersSelection?.translationLanguage.filterElements, (elem, id) => {
											const o = filter(filters.filtersSelection?.translationLanguage.filterElements, { active: true })[0]
											return (
												<option key={id} value={elem.id} selected={o.id === elem.id ? true : null}>
													{elem.label}
												</option>
											)
										})}
									</SelectInput>
								</SelectInputWrapper>
							</LanguagePartHeader>
							<TranslationIndexPartHeader>
								<LanguagePartLabel>{translations['page__translationManagement__subTitle__translationKey']} :</LanguagePartLabel>
							</TranslationIndexPartHeader>
						</PageWrapperHeaderGrids>

						<LanguagePartOverflow grids={3}>
							<ReferentialLanguagePartResultWrapper>
								{map(translationsManager.items, (elem, id) => {
									return (
										<div key={id}>
											<LanguageItemSpan>{elem.referentialTranslation.value}</LanguageItemSpan>
										</div>
									)
								})}
							</ReferentialLanguagePartResultWrapper>
							<TranslateLanguagePartResultWrapper>
								<form>
									{map(translationsManager.items, (elem, id) => {
										return (
											<div key={id}>
												<InputLogin
													name={`${elem.id}_input`}
													type="text"
													defaultValue={elem.actualTranslation.value}
													ref={register()}
													onBlur={(e) =>
														handleTranslationChange(
															elem.actualTranslation.idLanguage,
															elem.id,
															e.target.value,
															elem.actualTranslation.value
														)
													}
												/>
											</div>
										)
									})}
								</form>
							</TranslateLanguagePartResultWrapper>
							<TranslationIndexPartResultWrapper>
								{map(translationsManager.items, (elem, id) => {
									return (
										<div key={id}>
											<LanguageItemSpan>{elem.id}</LanguageItemSpan>
										</div>
									)
								})}
							</TranslationIndexPartResultWrapper>
						</LanguagePartOverflow>
					</Fragment>
				)}
			</TranslationsManagerWrapper>
		</Fragment>
	)
}

TranslationsManager.propTypes = {}

TranslationsManager.defaultPropTypes = {}

export default TranslationsManager
